var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "normal-page", attrs: { "body-style": { padding: 0 } } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                _vm._b({}, "el-col", _vm.gridl, false),
                [_c("left", { on: { eventOptionData: _vm.eventOptionData } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                _vm._b(
                  { staticClass: "assess-right" },
                  "el-col",
                  _vm.gridr,
                  false
                ),
                [
                  _c("div", { staticClass: "ml14 mr14" }, [
                    _c(
                      "div",
                      { staticClass: "clearfix el-card__header" },
                      [
                        _c("oaFromBox", {
                          attrs: {
                            search: _vm.searchData,
                            title: _vm.$route.meta.title,
                            total: _vm.total,
                            isViewSearch: false,
                            sortSearch: false,
                            btnText: "新建入口",
                          },
                          on: {
                            addDataFn: _vm.handleNews,
                            confirmData: _vm.confirmData,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt14 table-box" },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.tableData,
                              "row-key": "id",
                              "default-expand-all": "",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: "标题",
                                "min-width": "100",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", { staticClass: "over-text2" }, [
                                        _vm._v(_vm._s(scope.row.name)),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "pc_url",
                                label: "pc端地址",
                                "min-width": "120",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", { staticClass: "over-text2" }, [
                                        _vm._v(_vm._s(scope.row.pc_url)),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "uni_url",
                                label: "移动端地址",
                                "min-width": "120",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", { staticClass: "over-text2" }, [
                                        _vm._v(_vm._s(scope.row.uni_url)),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: "封面",
                                "min-width": "80",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.image
                                        ? _c("img", {
                                            staticClass: "table-img",
                                            attrs: {
                                              src: scope.row.image,
                                              alt: "",
                                            },
                                          })
                                        : _c("img", {
                                            staticClass: "table-img",
                                            attrs: {
                                              src: require("../../../../assets/images/index/quick-icon-09.png"),
                                              alt: "",
                                            },
                                          }),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "card.name",
                                label: "pc端显示",
                                "min-width": "80",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.pc_show === 1
                                              ? "显示"
                                              : "隐藏"
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "card.name",
                                label: "移动端显示",
                                "min-width": "90",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.uni_show === 1
                                              ? "显示"
                                              : "隐藏"
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "status",
                                label: "状态",
                                "min-width": "80",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-switch", {
                                        attrs: {
                                          "active-text": "开启",
                                          "inactive-text": "关闭",
                                          "active-value": 1,
                                          "inactive-value": 0,
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.handleStatus(scope.row)
                                          },
                                        },
                                        model: {
                                          value: scope.row.status,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "status", $$v)
                                          },
                                          expression: "scope.row.status",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "describe",
                                label: _vm.$t("public.operation"),
                                fixed: "right",
                                width: "120",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: ["system:quick:edit"],
                                              expression:
                                                "['system:quick:edit']",
                                            },
                                          ],
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleEdit(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("public.edit")))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: ["system:quick:delete"],
                                              expression:
                                                "['system:quick:delete']",
                                            },
                                          ],
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDelete(
                                                scope.row.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("public.delete")) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "paginationClass" },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "page-size": _vm.where.limit,
                                "current-page": _vm.where.page,
                                "page-sizes": [10, 15, 20],
                                layout: "total, prev, pager, next, jumper",
                                total: _vm.total,
                              },
                              on: {
                                "size-change": _vm.handleSizeChange,
                                "current-change": _vm.pageChange,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }